<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="this.tableData.length == 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="this.tableData.length > 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>departure_board</md-icon>
          </div>
          <h4 class="title">Chauffeurs laatste keer ingeroosterd / afwezig</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="this.tableData.length > 0"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Chauffeurs per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek shift(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Voornaam"
                md-sort-by="first_name"
              >
                {{ item.first_name }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Tussenvoegsel"
                md-sort-by="last_name_prefix_sort"
              >
                {{ item.last_name_prefix }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Achternaam"
                md-sort-by="last_name"
              >
                {{ item.last_name }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Laatst ingeroosterd"
                md-sort-by="days_last_scheduled_sort"
              >
                {{ item.days_last_scheduled }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Laatst ingeroosterd"
                md-sort-by="date_last_scheduled_sort"
              >
                {{ item.date_last_scheduled }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Laatst afwezig"
                md-sort-by="days_last_unavailable_sort"
              >
                {{ item.days_last_unavailable }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Laatst afwezig"
                md-sort-by="date_last_unavailable_sort"
              >
                {{ item.date_last_unavailable }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions
          v-if="this.tableData.length > 0"
          md-alignment="space-between"
        >
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van
              {{ total }} chauffeurs
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "days_last_scheduled",
      currentSortOrder: "desc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      footerTable: [
        "Naam",
        "Reserve",
        "Groep",
        "Volgorde",
        "Volgorde",
        "Volgorde",
        "Volgorde"
      ],
      searchQuery: "",
      propsToSearch: [
        "first_name",
        "last_name_prefix",
        "last_name",
        "email",
        "days_last_scheduled",
        "date_last_scheduled",
        "days_last_unavailable",
        "date_last_unavailable"
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    loadDriversLastScheduled() {
      this.$http.get(this.$apiBaseUrl + "drivers/last-scheduled").then(
        response => {
          let tableData = [];

          for (let i in response.data.drivers_last_scheduled) {
            let row = response.data.drivers_last_scheduled[i];

            row["last_name_prefix_sort"] = row["last_name_prefix"] ?? "";
            row["days_last_scheduled_sort"] =
              row["days_last_scheduled"] ?? 99999;
            row["date_last_scheduled_sort"] =
              row["days_last_scheduled"] ?? "1970-01-01";
            row["days_last_unavailable_sort"] =
              row["days_last_unavailable"] ?? 99999;
            row["date_last_unavailable_sort"] =
              row["date_last_unavailable"] ?? "1970-01-01";

            tableData.push(row);
          }

          this.tableData = tableData;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: [
              "first_name",
              "last_name_prefix",
              "last_name",
              "email",
              "days_last_scheduled",
              "date_last_scheduled",
              "days_last_unavailable",
              "date_last_unavailable"
            ],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van shifts",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    handleEdit(item) {
      this.$router.push("/shifts/edit/" + item.id);
    },
    handlePeriods(item) {
      this.$router.push("/shifts/periods/" + item.id);
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Shift "${item.name}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.delete(this.$apiBaseUrl + "shifts/" + item.id).then(
            response => {
              this.deleteRow(item);

              this.notifyVue(
                "Shift succesvol verwijderd",
                "check",
                "success",
                5000
              );

              // Fuse search initialization.
              this.fuseSearch = new Fuse(this.tableData, {
                keys: ["name", "group", "order"],
                threshold: 0.3
              });
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het beheren van shifts",
                  "add_alert",
                  "danger",
                  0
                );
              }
            }
          );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {
    this.loadDriversLastScheduled();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css">
.paginated-table .md-table-cell:last-child .md-table-cell-container,
.paginated-table .md-table-head:last-child {
  text-align: start !important;
  justify-content: normal;
}
</style>
